import { Trans } from 'react-i18next';

const EMAIL_NOT_DELIVERED = 'emailNotDelivered';
const EMAIL_DELIVERED = 'emailDelivered';
const EMAIL_OPENED = 'emailOpened';
const EMAIL_SENT = 'emailSent';
const GIFT_LINK_CREATED = 'giftLinkCreated';
const GIFT_OPENED = 'giftOpened';
const GIFT_REDEEMED = 'giftRedeemed';
const GIFT_DELIVERED = 'giftDelivered';
const ORDER_ACCEPTED = 'orderAccepted';
const ORDER_SUBMISSION_PENDING = 'orderSubmissionPending';
const ORDER_SUBMISSION_STARTED = 'orderSubmissionStarted';
const ORDER_SUBMISSION_SKIPPED = 'orderSubmissionSkipped';
const ORDER_SUBMISSION_FAILED = 'orderSubmissionFailed';
const ORDER_SUBMITTED = 'orderSubmitted';
const ORDER_DELIVERED = 'orderDelivered';
const UPCOMING = 'upcoming';

const ACCEPTED = 'accepted';
const INJECTED = 'injected';
const INVOICE_CREATED = 'invoiceCreated';
const NO_INVOICE_YET = 'noInvoiceYet';
const OPENED = 'opened';
const UNOPENED = 'unopened';
const APPROVED = 'approved';
const PENDING_APPROVAL = 'pending_approval';

const GIFT_STATUSES = {
  [EMAIL_NOT_DELIVERED]: EMAIL_NOT_DELIVERED,
  [EMAIL_DELIVERED]: EMAIL_DELIVERED,
  [EMAIL_OPENED]: EMAIL_OPENED,
  [EMAIL_SENT]: EMAIL_SENT,
  [GIFT_LINK_CREATED]: GIFT_LINK_CREATED,
  [GIFT_OPENED]: GIFT_OPENED,
  [GIFT_REDEEMED]: GIFT_REDEEMED,
  [GIFT_DELIVERED]: GIFT_DELIVERED,
  [ORDER_ACCEPTED]: ORDER_ACCEPTED,
  [ORDER_SUBMISSION_PENDING]: ORDER_SUBMISSION_PENDING,
  [ORDER_SUBMISSION_STARTED]: ORDER_SUBMISSION_STARTED,
  [ORDER_SUBMISSION_SKIPPED]: ORDER_SUBMISSION_SKIPPED,
  [ORDER_SUBMISSION_FAILED]: ORDER_SUBMISSION_FAILED,
  [ORDER_SUBMITTED]: ORDER_SUBMITTED,
  [ORDER_DELIVERED]: ORDER_DELIVERED,
  [UPCOMING]: UPCOMING
};

const ORDER_STATUSES = {
  [ACCEPTED]: ACCEPTED,
  [INJECTED]: INJECTED,
  [INVOICE_CREATED]: INVOICE_CREATED,
  [NO_INVOICE_YET]: NO_INVOICE_YET,
  [OPENED]: OPENED,
  [UNOPENED]: UNOPENED,
  [APPROVED]: APPROVED,
  [PENDING_APPROVAL]: PENDING_APPROVAL
};

const EDITABLE_TIMELINE_STATUS = [
  EMAIL_NOT_DELIVERED,
  EMAIL_DELIVERED,
  EMAIL_OPENED,
  EMAIL_SENT,
  GIFT_LINK_CREATED,
  GIFT_OPENED
];

const FILTER_BY_GIFT_STATUS = [
  { label: <Trans i18nKey="emailNotDelivered" />, value: EMAIL_NOT_DELIVERED },
  { label: <Trans i18nKey="emailSent" />, value: EMAIL_DELIVERED },
  { label: <Trans i18nKey="emailOpened" />, value: EMAIL_OPENED },
  { label: <Trans i18nKey="giftOpened" />, value: GIFT_OPENED },
  { label: <Trans i18nKey="giftRedeemed" />, value: ORDER_ACCEPTED },
  { label: <Trans i18nKey="orderSubmissionFailed" />, value: ORDER_SUBMISSION_FAILED }
];

const FILTER_BY_GIFT_STATUS_NUMBER_TYPE = [
  { label: <Trans i18nKey="giftRedeemed" />, value: ORDER_ACCEPTED },
  { label: <Trans i18nKey="orderSubmissionFailed" />, value: ORDER_SUBMISSION_FAILED }
];

export {
  EDITABLE_TIMELINE_STATUS,
  EMAIL_DELIVERED,
  EMAIL_NOT_DELIVERED,
  EMAIL_OPENED,
  EMAIL_SENT,
  FILTER_BY_GIFT_STATUS,
  FILTER_BY_GIFT_STATUS_NUMBER_TYPE,
  GIFT_LINK_CREATED,
  GIFT_OPENED,
  GIFT_STATUSES,
  ORDER_ACCEPTED,
  ORDER_DELIVERED,
  ORDER_STATUSES,
  ORDER_SUBMISSION_FAILED,
  ORDER_SUBMISSION_PENDING,
  ORDER_SUBMISSION_SKIPPED,
  ORDER_SUBMISSION_STARTED,
  ORDER_SUBMITTED
};
